<template>
  <v-layout row justify-center>
    <v-dialog v-model="value" persistent content content-class="centered-dialog">
      <v-container fill-height>
        <v-layout column justify-center align-center>
          <v-progress-circular indeterminate :size="70" :width="7" :color="progressColor"></v-progress-circular>
          <h1 v-if="message != null">{{message}}</h1>
        </v-layout>
      </v-container>
    </v-dialog>
  </v-layout>
</template>

<script lang="ts">
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component({
  components: {
  },
})
export default class FullScreenLoad extends Vue {

  // @Prop({ default: () => false}) public value: boolean;
  // @PropSync('value', { type: boolean }) v!: boolean;
  @Prop() public message!: string | null;
  @Prop({ default: () => false }) public value!: boolean;
  @Prop({ default: () => 'purple' }) public progressColor!: string;

  // private v: boolean = false;
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="css">
.dialog.centered-dialog,
.v-dialog.centered-dialog
 {
    background: transparent;
    box-shadow: none;
    border-radius: 6px;
    width: auto;
    color: whitesmoke;
  }
</style>